module.exports = __webpack_public_path__ + "img/agco.7daa8686.png";